<template>
  <div :class="size">
    <div class="crowd-box">
      <div class="crowd-box-photo">
        <router-link :to="{ name: 'show_crowdfunding', params: { id: project.id, title: project.title.replace(/ /g, '-') } }">
          <img v-if="project.photo.thumb.url" :src="$server_url + project.photo.thumb.url">
          <img v-else src="~assets/img/projectPlaceholder.png">
        </router-link>
      </div>
      <!-- crowd-box-photo -->
      <div class="crowd-box-text">
        <router-link :to="{ name: 'crowdfunding', query: { category: project.category.name }}" class="category">
          {{ project.category.name }}
        </router-link>
        <span v-if="showStatus" class="days-left pull-right">
          {{ $t(`project.status.${project.status}`) }}
        </span>
        <br/>
        <router-link :to="{ name: 'show_crowdfunding', params: { id: project.id, title: project.title.replace(/ /g, '-') } }" class="title">
          {{ project.title }}
        </router-link>
        <br/>
        <router-link :to="{ name: 'show_profile', params: { id: project.user.id } }" class="author">
          {{ project.user.full_name }}
        </router-link>
        <br/>
        <p class="short-desc">{{ project.description }}</p>
        <p class="allready-raised">
          {{ project.currency | currencySymbol }} {{ project.collected | price }}
        </p>
        <div class="bar-goal">
          <div class="bar-raised" :style="{ width: completion + '%' }"></div>
        </div>
        <div class="goal-percent">{{ completion }}%</div>
        <div class="days-left">
          <div v-if="project.deadline && project.status === 'published'">
            {{ project.deadline | daysLeft }} {{ $t('project.daysLeft') }}
          </div>
          <div v-if="project.deadline && project.status === 'successful'">{{ $t('project.ended') }}</div>
          <div v-if="!project.deadline">{{ project.duration + ' ' + $t('project.daysLeft')}}</div>
        </div>
      </div><!-- crowd-box-text -->
    </div><!-- crowd-box -->
  </div><!-- col-md-6 -->
</template>

<script>
export default {
  props: ['project', 'size', 'showStatus'],
  computed: {
    completion() {
      return Math.round((this.project.collected / this.project.to_collect) * 100);
    },
  },
};
</script>



// WEBPACK FOOTER //
// Crowdfunding.vue?c513112a